/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Assigned_To_HeaderInputs */

const en_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned To`)
};

const fr_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigne a`)
};

const de_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen an`)
};

const it_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnato a`)
};

const ru_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначен в`)
};

const es_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignado a`)
};

const zh_cn2_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分配给`)
};

const ja_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当て先`)
};

const hi_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`को सौंपना`)
};

const pt_pt2_explorer_table_assigned_to_header = /** @type {(inputs: Explorer_Table_Assigned_To_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designado para`)
};

/**
* | output |
* | --- |
* | "Assigned To" |
*
* @param {Explorer_Table_Assigned_To_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_assigned_to_header = /** @type {((inputs?: Explorer_Table_Assigned_To_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Assigned_To_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_assigned_to_header(inputs)
	if (locale === "de") return de_explorer_table_assigned_to_header(inputs)
	if (locale === "it") return it_explorer_table_assigned_to_header(inputs)
	if (locale === "ru") return ru_explorer_table_assigned_to_header(inputs)
	if (locale === "es") return es_explorer_table_assigned_to_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_assigned_to_header(inputs)
	if (locale === "ja") return ja_explorer_table_assigned_to_header(inputs)
	if (locale === "hi") return hi_explorer_table_assigned_to_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_assigned_to_header(inputs)
	return en_explorer_table_assigned_to_header(inputs)
});